module.exports = __webpack_public_path__ + "media/images/city/059-holy-family-23da4e87641bd8b8edc3b8624605b812.svg";